import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { Grid, Typography, LinearProgress, Slide } from '@material-ui/core';

const ICON_LOOKUP = {
  loading: <LinearProgress variant="indeterminate" />,
  error: <ErrorIcon fontSize="large" style={{ fill: '#f44336' }} />,
  success: <CheckCircleIcon fontSize="large" style={{ fill: '#4caf50' }} />,
};

const TITLE_LOOKUP = {
  loading: 'Loading',
  error: 'Error',
  success: 'Success',
};

const StatusState = (props) => {
  const {
    loading,
    success,
    error,
    msg,
    title,
    children,
    timeout,
    onLoad,
  } = props;
  const [showAction, setShowAction] = useState(false);

  // By doing it this way, loading will be default
  const type = error ? 'error' : success ? 'success' : 'loading';

  if (children) {
    setTimeout(() => setShowAction(true), timeout || 1000);
  }

  if (onLoad) onLoad();

  return (
    <Grid container spacing={10}>
      <Grid container item xs={12} justify="center" spacing={2}>
        <Grid item xs={12}>
          <Typography align="center">{title || TITLE_LOOKUP[type]}</Typography>
        </Grid>
        <Grid item xs={7} style={{ textAlign: 'center' }}>
          {ICON_LOOKUP[type]}
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="body2"
            align="center"
            style={{ maxWidth: 400, margin: 'auto' }}
          >
            {msg || ''}
          </Typography>
        </Grid>
      </Grid>

      {children ? (
        <Grid container item xs={12} justify="center" spacing={2}>
          <Slide direction="up" in={showAction} mountOnEnter>
            {children}
          </Slide>
        </Grid>
      ) : (
        ''
      )}
    </Grid>
  );
};
StatusState.defaultProps = {
  children: undefined,
  error: false,
  loading: false,
  msg: '',
  success: false,
  title: '',
};
StatusState.propTypes = {
  error: PropTypes.bool,
  loading: PropTypes.bool,
  msg: PropTypes.string,
  success: PropTypes.bool,
  title: PropTypes.string,
};

export default StatusState;
